// angular
// .module("HeroPRO")
// .controller("ApplicationController", applicationController);

/* @ngInject */
export default function applicationController($stateParams, SearchService, $state) {
    init();

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
        // SearchCriteria 5 = HEROId
        const params = {
            SearchCriteria: 5,
            SearchValue: $stateParams.HEROId,
        };

        SearchService.search(params).then((response) => {
            if (response.data.Data.PipelineFundingRequests !== undefined) {
                // Redirect to the first funding request that is returned
                $state.go('app-detail', { appId: response.data.Data.PipelineFundingRequests[0].FundingRequestId });
            } else {
                // Funding request not found with the HEROId passed
                $state.go('dashboard');
            }
        });
    }
    /* -----  End of Private Functions  ------*/

    /*= =======================================
    =            Public Functions            =
    ======================================== */

    /* -----  End of Public Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/application/applicationController.js